<template>
  <div id="Jibenzoushi">
    <div class="tr-header">
      <p class="title">龙虎走势</p>
      <div class="handles" v-if="betType != 'xyrb' && betType != 'ks'">
        <span
          @click="handleChecked('today', '0')"
          :class="{'checked': checked === '0'}"
          class="handle"
        >今天</span>
        <span
          @click="handleChecked('yesterday', '1')"
          :class="{'checked': checked === '1'}"
          class="handle"
        >昨天</span>
        <span
          @click="handleChecked('beforeYesterday', '2')"
          :class="{'checked': checked === '2'}"
          class="handle"
        >前天</span>
        <span
          @click="handleChecked('30', '3')"
          :class="{'checked': checked === '3'}"
          class="handle"
        >最近 30 期</span>
        <span
          @click="handleChecked('60', '4')"
          :class="{'checked': checked === '4'}"
          class="handle"
        >最近 60 期</span>
        <span
          @click="handleChecked('90', '5')"
          :class="{'checked': checked === '5'}"
          class="handle"
        >最近 90 期</span>
      </div>
    </div>
    <div class="tr-table-container">
      <div class="check_box">
        <span>标注选择:</span>
        <CheckboxGroup v-model="showList" @on-change="checkAllGroupChange">
          <Checkbox label="yilou">遗漏</Checkbox>
          <Checkbox label="zhexian">折线</Checkbox>
          <Checkbox label="yifen">遗漏分成</Checkbox>
          <!-- <Checkbox label="西瓜"></Checkbox> -->
        </CheckboxGroup>
      </div>
      <Table width="100%" :columns="columns" :data="dataSource" border></Table>
    </div>
    <div class="tr-table-container">
      <Table width="100%" :columns="lostColumns" :data="lostList" border></Table>
    </div>
    <div class="describe" v-html="describe"></div>
  </div>
</template>

<script>
import columns from "./columns";
import dayjs from "dayjs";
import format from "../../../helpers/format.js";

export default {
  name: "Jibenzoushi",
  data() {
    return {
      showList: ["yilou", "zhexian"],
      columns: [],
      pageSize: 30,
      dataSource: [],
      checked: "3",
      checkedButton: "6",
      lostColumns: [],
      lostList: [],
      describe: ""
    };
  },
  computed: {
    betType() {
      return this.$route.params.betType;
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.getDate();
      }
    }
  },
  methods: {
    checkAllGroupChange() {
      this.$emit("checkAllGroupChange", this.showList);
      // var lostList = document.querySelectorAll(".lost_info");
      // var canvas = document.querySelector(".cvs_container");

      // if (!this.showList.includes("yilou")) {
      //   for (let i = 0; i < lostList.length; i++) {
      //     const e = lostList[i];
      //     e.style.display = "none";
      //   }
      // } else {
      //   for (let i = 0; i < lostList.length; i++) {
      //     const e = lostList[i];
      //     e.style.display = "inline-block";
      //   }
      // }
      // if (!this.showList.includes("zhexian")) {
      //   canvas.style.display = "none";
      // } else {
      //   canvas.style.display = "inline-block";
      // }
    },

    handleChecked(agt, index) {
      this.startDate = "";
      this.pageSize = "";
      this.checked = index;
      var year = dayjs().year();
      var month = ("00" + (dayjs().month() + 1)).slice(-2);
      var date = ("00" + dayjs().date()).slice(-2);
      if (agt == "today") {
        this.startDate = `${year}-${month}-${date}`;
      } else if (agt == "yesterday") {
        // date -= 1;
        date = ("00" + (date - 1)).slice(-2);
        this.startDate = `${year}-${month}-${date}`;
      } else if (agt == "beforeYesterday") {
        // date -= 2;
        date = ("00" + (date - 2)).slice(-2);
        this.startDate = `${year}-${month}-${date}`;
      } else if (agt == "30") {
        this.pageSize = 30;
      } else if (agt == "60") {
        this.pageSize = 60;
      } else if (agt == "90") {
        this.pageSize = 90;
      }
      this.getDate();
    },
    reset(data) {
      this.columns = columns(this.betType, data).list(this);
      this.lostColumns = columns(this.betType, data).lostList(this);
      this.describe = columns(this.betType, data).describe;
    },
    async getDate() {
      // /queryKcReportByIssue.do?gameType=CQSSC
      let req = {
        gameType: this.$route.params.gameType,
        isNeed: 1,
        num: this.pageSize,
        date: this.startDate
      };
      let res = await this.$http.post("/queryKcReportByIssue.do", req);
      if (res.data.returnCode == "0000") {
        var arr = format.formatLonghu(res.data.returnList);
        this.formatLost(res.data.returnMap);
        this.dataSource = arr;

        this.reset(arr);
        this.$nextTick(() => {
          window.scrollTo(0, 0);
          var canvas = document.querySelector(".cvs_container");
          let table = document.querySelector(".ivu-table-tbody");
          if (canvas) {
            // canvas.style.display = "none";
            table.removeChild(canvas);
            // canvas.removeNode(true);
          }
          this.createCanvas();
        });
      } else {
        this.$Message.error(res.data.returnMessage);
      }
    },
    formatLost(arg) {
      var o = {
        allOpen: "出现次数", //出现次数
        // joinOpen: "当前连开",
        // averageOmit: "平均遗漏",
        maxOmit: "最大遗漏", //
        maxJoin: "最大连出" //
        // nowOmit: "当前遗漏"
      };
      // var lhJson = arg.lhJson;
      var arr = [];

      for (const key in o) {
        var obj = {};
        obj.name = o[key];
        obj.key = key;
        obj.lost = arg;
        arr.push(obj);
      }
      this.lostList = arr;
    },
    // 走势图
    createCanvas() {
      let tableContent = document.querySelector(".tr-table-container");
      let table = document.querySelector(".ivu-table-tbody");
      let tablePos = table.getBoundingClientRect();
      let tableleft = tablePos.left;
      let tabletop = tablePos.top;
      //设置画布
      let cvs = document.createElement("canvas");
      cvs.style.marginTop = -table.offsetHeight + "px";
      cvs.className = "cvs_container";
      cvs.height = table.offsetHeight; // 表格的高度等同画布高度
      cvs.width = table.scrollWidth; // 表格的高度等同画布高度
      var redList = document.querySelectorAll(".red");
      let length = this.dataSource[0].ballList.length; // 开奖球数 5  就是列数
      let redLength = redList.length; // 中奖号码球数 150
      let canvasArr = []; // 画笔坐标系
      for (let i = 0; i < length; i++) {
        canvasArr[i] = new Array();
        for (let j = 0; j < this.dataSource.length; j++) {
          var num = i + length * j;
          let dom = redList[num];
          let pos = dom.getBoundingClientRect();
          let left = pos.left + dom.offsetHeight / 2;
          let top = pos.top + dom.offsetWidth / 2;
          let a = { left: left - tableleft, top: top - tabletop - 15 };
          canvasArr[i].push(a);
        }
      }
      for (let i = 0; i < canvasArr.length; i++) {
        let colors = {
          0: "#fba75e",
          1: "#1fa6e8",
          2: "#0abe02",
          3: "#8485fb",
          4: "#46bd94",
          5: "#e16baa",
          6: "#f2b653",
          7: "#628ef3",
          8: "#5ec642",
          9: "#f66d6d"
        };
        let color = colors[i];
        let cxt = cvs.getContext("2d"); // 画笔
        cxt.strokeStyle = color; // 颜色
        cxt.beginPath();
        let it = canvasArr[i];
        if (it.length > 0) {
          cxt.moveTo(it[0].left, it[0].top);
          for (let j = 0; j < it.length; j++) {
            cxt.lineTo(it[j].left, it[j].top);
            cxt.stroke();
          }
        }
      }
      table.append(cvs); // 将绘画好的走势图接入表格dom树
    }
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/Trend/Longhuzoushi/index.vue